import { render, staticRenderFns } from "./MallHotelAdd.vue?vue&type=template&id=7014bbfb&scoped=true&"
import script from "./MallHotelAdd.vue?vue&type=script&lang=js&"
export * from "./MallHotelAdd.vue?vue&type=script&lang=js&"
import style0 from "./MallHotelAdd.vue?vue&type=style&index=0&id=7014bbfb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7014bbfb",
  null
  
)

export default component.exports